import { TaxType } from './reference-book-taxpayer-codes.types';

export const records: TaxType[] = [
    {
        index: 1,
        code: 101105,
        name: 'Корпоративный подоходный налог с юридических лиц организаций нефтяного сектора.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 2,
        code: 101110,
        name: 'Корпоративный подоходный налог с юр.лиц, за искл. поступлений от организаций нефт.сект.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 3,
        code: 101201,
        name: 'Индивидуальный подоходный налог с доходов, облагаемых у источника выплаты.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: false,
    },
    {
        index: 4,
        code: 101202,
        name: 'Индивид. подоход. налог с доходов, не облагаемых у источника выплаты',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: true,
        fl: true,
    },
    {
        index: 5,
        code: 101205,
        name: 'Индивид. подох. налог с доходов иностр.гр-н, не облагаемых у источника выплаты',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: true,
        fl: true,
    },
    {
        index: 6,
        code: 103101,
        name: 'Социальный налог',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: false,
    },
    {
        index: 7,
        code: 104101,
        name: 'Налог на имущество юр.лиц и индив. предпр-ей',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: false,
    },
    {
        index: 8,
        code: 104102,
        name: 'Hалог на имущество физ.лиц',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: false,
        fl: true,
    },
    {
        index: 9,
        code: 104302,
        name: 'Земельный налог с физ. лиц на земли населенных пунктов',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: false,
        fl: true,
    },
    {
        index: 10,
        code: 104309,
        name: 'Земельный налог, за исключением земельного налога с физ. лиц на земли населенных пунктов',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 11,
        code: 104401,
        name: 'Hалог на транспортные средства с юр.лиц',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 12,
        code: 104402,
        name: 'Hалог на транспортные средства с физ.лиц',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: true,
        fl: true,
    },
    {
        index: 13,
        code: 104501,
        name: 'Единый земельный налог',
        bic: 'KKMFKZ2A',
        ul: false,
        ip: true,
        fl: false,
    },
    {
        index: 14,
        code: 105101,
        name: 'Hалог на доб.стоимость на произв. товары, выпол. работы и оказан. услуги на терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 15,
        code: 105102,
        name: 'HДС на товары, импорт.на терр.РК, кр.НДС на товары, импорт.с терр.РФ и Республики Беларусь',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 16,
        code: 105104,
        name: 'Налог на доб. стоимость за нерезидента',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 17,
        code: 105113,
        name: 'НДС на товары, происходящие и имп. с терр. РФ и РБ до созд. единой тамож. терр. ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 18,
        code: 105114,
        name: 'Переч.(возврат) НП суммы превыш. НДС, ранее возвращ. из бюдж. и не подтвер.к возвр. при пров. нал.проверки, перечисление суммы пени',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 19,
        code: 105115,
        name: 'НДС на товары, имп. с терр. Государств-членов ЕАЭС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 20,
        code: 105229,
        name: 'Сырая нефть, газовый конденсат, произвед. на терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 21,
        code: 105274,
        name: 'Акцизы на все виды спирта и (или) виноматер., алкогол. прод.,произвед. на терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 22,
        code: 105275,
        name: 'Таб. изделия, легковые авто. (кроме авто. с руч. Управ. или адап. Ручн. управ, специально предназначенных для инвалидов), произведенные на терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 23,
        code: 105276,
        name: 'Таб. изделия, ввоз. на терр. РК с терр. государств-членов ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 24,
        code: 105277,
        name: 'Все виды спирта и (или) виноматериала, алкогольной продукции, ввозимых на территорию РК с терр. государств-членов ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 25,
        code: 105278,
        name: 'Прочие виды подакцизной продукции, ввозимой на территорию РК с терр. государств-членов ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 26,
        code: 105279,
        name: 'Бензин (за искл. Авиац.) и диз. топливо, ввозимых на терр. РК с терр. государств-членов ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 27,
        code: 105280,
        name: 'Все виды спирта и (или) вином., алкогол. Прод., импортируемых на терр. РК с терр. государств, не являющихся членами ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 28,
        code: 105281,
        name: 'Табачные изд., имп. на терр. РК, кроме товаров ТС, ввозимых с терр. РФ и РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 29,
        code: 105282,
        name: 'Акцизы прочие виды подакцизных продукций, импортируемые на терр. РК, кроме товаров ТС, ввозимых с терр. РФ и РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 30,
        code: 105283,
        name: 'Бензин (за исключением авиационного) и дизельное топливо, импортируемых на территорию РК с терр. государств, не являющихся членами ТС',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 31,
        code: 105284,
        name: 'Бензин (за исключением авиационного) и дизельное топливо, произведенных на терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 32,
        code: 105301,
        name: 'Плата за предоставл.междугор.и (или) междунар.телеф.связи, а также сот.связи',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 33,
        code: 105302,
        name: 'Налог на сверхприбыль, за искл.поступл.от организаций нефтяного сектора ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 34,
        code: 105303,
        name: 'Плата за пользов. водными ресурсами поверхностных источников',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 35,
        code: 105304,
        name: 'Плата за лесные пользования',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 36,
        code: 105305,
        name: 'Бонусы, за исключением поступлений от организаций нефтяного сектора ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 37,
        code: 105306,
        name: 'Налог на добычу полезных ископаемых, за искл.поступл.от организ. нефт.сект.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 38,
        code: 105307,
        name: 'Рентный налог на экспорт, за искл.поступл.от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 39,
        code: 105308,
        name: 'Доля РК по разделу продукции по заключенным контрактам, за искл.поступл.от организаций нефт.сект.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 40,
        code: 105309,
        name: 'Плата за исп. радиочастотного спектра',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 41,
        code: 105310,
        name: 'Плата за пользов. судоходными водными путями',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 42,
        code: 105311,
        name: 'Плата за пользов. животным миром',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 43,
        code: 105313,
        name: 'Плата за исп. особо охраняемых прир. терр. респуб. знач.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 44,
        code: 105314,
        name: 'Плата за исп. особо охраняемых прир. терр. мест. знач.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 45,
        code: 105315,
        name: 'Плата за польз. зем. участками',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 46,
        code: 105316,
        name: 'Плата за эмиссии в окр. среду',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 47,
        code: 105319,
        name: 'Платеж по возмещению исторических затрат',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 48,
        code: 105322,
        name: 'Налог на сверхприбыль от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 49,
        code: 105325,
        name: 'Бонусы от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 50,
        code: 105326,
        name: 'Налог на добычу полезных ископаемых от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 51,
        code: 105327,
        name: 'Рентный налог на экспорт от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 52,
        code: 105328,
        name: 'Доля РК по разделу продукции по заключенным контрактам от организаций нефтяного сектора',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 53,
        code: 105329,
        name: 'Доп.платеж недропользователя, осуществл.деят.по контракту о разделе продукции, от организаций нефт.сект.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 54,
        code: 105402,
        name: 'Лиценз. сбор за право занятия отд. видами деят-ти',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 55,
        code: 105404,
        name: 'Сбор с аукционов',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 56,
        code: 105406,
        name: 'Сбор за проезд автотр. ср-в по терр. РК',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 57,
        code: 105413,
        name: 'Сбор за выдачу разреш. на исп. радиочаст. спектра телевиз. и радиовещ. орг-ям',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 58,
        code: 105419,
        name: 'Плата за размещ. нар.(виз.) рекл. на объек. стац. разм. рекл. в пол. отв. авт. дор. общ. польз. респ. зн., за искл. авт. дор.общ.польз.респ.зн., прох.чз терр. гор.рай.зн.,сел,пос.,сел.окр.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 59,
        code: 105420,
        name: 'Плата за размещ. нар. (виз.) рекл. на объек. стац. разм. рекл. в пол. отв. авт. дор. общ. польз. обл. зн., за искл. пл.за разм. нар.(виз.) рекл. на объек. стац. разм. рекл. в пол. отв. авт. ДОП обл. зн., прох. ч-з терр. гор. рай. зн., сел, пос., сел. окр.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 60,
        code: 105424,
        name: 'Плата за размещ. нар.(виз.) рекл. на откр. простр. за пред. помещ. в гор. респ. зн., столице и на трансп. сред., зарег. в гор. респ. зн., столице',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 61,
        code: 105425,
        name: 'Плата за разм.нар.(виз.) рекл. на откр.прос. за пред.пом. в гор.обл.зн.и на ТС, зарег.в гор.обл.зн., за искл.пл.за разм.нар.(виз.) рекл.на об.стац.разм.рекл.в пол.отв.авт. ДОП рай.зн.,на отк.пр.за пред.пом.в гор.рай.зн., селе, пос. и на ТС,зарег.в рай.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 62,
        code: 105428,
        name: 'Рег. сбор, зачисл. в респ. бюджет',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 63,
        code: 105429,
        name: 'Рег. сбор, зачисл. в местный бюджет',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 64,
        code: 105501,
        name: 'Налог на игорный бизнес',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: false,
        fl: false,
    },
    {
        index: 65,
        code: 105502,
        name: 'Фиксированный налог',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: false,
    },
    {
        index: 66,
        code: 106101,
        name: 'Ввозные тамож. пош. (иные пошлины, налоги и сборы, имеющие эквивалентное действие), уплаченные в соотв. с Договором о Евразийском эконом. союзе',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 67,
        code: 106102,
        name: 'Таможенные пошлины на вывозимые товары',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 68,
        code: 106104,
        name: 'Тамож. пошл., налоги на ввоз. ФЛ тов. для личн. польз. с прим. ед. ставок тамож. пошл., налогов',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 69,
        code: 106105,
        name: 'Совокупный таможенный платеж на ввозимые товары',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 70,
        code: 106106,
        name: 'Таможенные пошлины, распред. РФ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 71,
        code: 106107,
        name: 'Таможенные пошлины, распред. РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 72,
        code: 106108,
        name: 'Суммы распред. ввозных тамож. пошл., перечисл. кот. приостановлено',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 73,
        code: 106109,
        name: 'Суммы % за проср. за неисп., неполное и (или) несвоевр. исп. обяз. по переч. сумм от распред. ввозн. тамож. пошл.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 74,
        code: 106110,
        name: 'Вывозн. тамож. пошл. на сырую нефть',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 75,
        code: 106111,
        name: 'Вывозн. тамож. пошл. на товары, выработанные из нефти',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 76,
        code: 106112,
        name: 'Там.пошл. на ввоз.тов.и (или) ввоз.там.пошл., обяз. по упл. кот. возн. до вступ.в силу Соглаш.об уст. и прим. в ТС п-ка зачис. и распр. ввоз. там.пошл. (ин. пошл., нал. и сборов, им.эквивал. действие)',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 77,
        code: 106113,
        name: 'Таможенные пошлины, распределенные Республикой Армения',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 78,
        code: 106114,
        name: 'Взыск. суммы обесп. уплаты тамож. пошлин, налогов, поступ. из РФ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 79,
        code: 106115,
        name: 'Взыск. суммы обесп. уплаты тамож. пошлин, налогов, поступ. из РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 80,
        code: 106116,
        name: 'Взысканные суммы обеспечения уплаты таможенных пошлин, налогов, поступающие из Республики Армения',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 81,
        code: 106117,
        name: 'Таможенные пошлины, распределенные КР',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 82,
        code: 106118,
        name: 'Взысканные суммы обеспечения уплаты таможенных пошлин, налогов, поступающие от КР',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 83,
        code: 106201,
        name: 'Поступл. от осущ. тамож. контроля и тамож. процедур',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 84,
        code: 106202,
        name: 'Спец., антидемпинговые, компенсационные пошлины, уплаченные в соотв. с Договором о Евразийском экономическом союзе',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 85,
        code: 106205,
        name: 'Специальные, антидемпинговые, компенсационные пошлины, поступившие от РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 86,
        code: 106206,
        name: 'Специальные, антидемпинговые, компенсационные пошлины, поступившие от РФ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 87,
        code: 106207,
        name: 'Суммы процентов за просрочку за неисполнение или (неполное) несвоевр.исп. обязат. по перечислению сумм от распред. спец. защитных, антидемп.и компенсац.пошлин',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 88,
        code: 106208,
        name: 'Спец. защитные, антидемпинговые и компенсационные пошлины, не подлежащие распределению',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 89,
        code: 106209,
        name: 'Специальные, антидемпинговые, компенсационные пошлины, поступившие от Республики Армения',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 90,
        code: 106210,
        name: 'Суммы распределенных специальных, антидемпинговых, компенсационных пошлин, перечисление которых приостановлено',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 91,
        code: 106211,
        name: 'Специальные, антидемпинговые, компенсационные пошлины, поступившие от КР',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 92,
        code: 107109,
        name: 'Прочие налоговые поступления в РБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 93,
        code: 107110,
        name: 'Прочие налоговые поступления в МБ',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 94,
        code: 108101,
        name: 'Консульский сбор',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 95,
        code: 108125,
        name: 'Государственная пошлина, зачисляемая в республиканский бюджет',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 96,
        code: 108126,
        name: 'Государственная пошлина, зачисляемая в местный бюджет',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 97,
        code: 204162,
        name: 'Адм.штр.,пени, санк., взыск., нал. Ком. гос. дох. Мин. фин. РК, его терр. орг. фин. из респ. бюдж., за искл. пост. от орг. нефт. сект.',
        bic: 'KKMFKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 98,
        code: null,
        name: 'Поступления в пенсионный фонд 901101',
        bic: 'GCVPKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 99,
        code: null,
        name: 'Поступления социальных отчислений',
        bic: 'GCVPKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
    {
        index: 100,
        code: null,
        name: 'Поступления обязат. пенсионн. профессион. взносов',
        bic: 'GCVPKZ2A',
        ul: true,
        ip: true,
        fl: true,
    },
];
